import { useGetSchemaDetails } from 'Hooks/graphql/getSchemaDetails.generated';
import { Alert, Flex, Spinner } from 'pounceV2';
import SchemaViewerV3 from 'Pages/Configure/components/SchemaViewerV3';
import React from 'react';
import { extractErrorMessage } from 'Helpers/utils';

const SchemaViewerTabPanelV3 = ({ schemaName }) => {
  const { data, loading, error } = useGetSchemaDetails({
    variables: { input: { name: schemaName } },
  });

  if (error || data?.getSchema?.error) {
    return (
      <Alert
        variant="error"
        title="Could not load schema"
        description={
          extractErrorMessage(error) ||
          "An unknown error occurred and we couldn't load the schema from the server"
        }
      />
    );
  }

  if (loading) {
    return (
      <Flex justify="center" align="center" height="500px">
        <Spinner size="large" />
      </Flex>
    );
  }

  return <SchemaViewerV3 schema={data.getSchema.schema} />;
};

export default SchemaViewerTabPanelV3;
